<form class="event-form" [formGroup]="eventForm()">
  <mat-form-field class="event-form__input" appearance="fill">
    <mat-label for="name">Event Name</mat-label>
    <input matInput formControlName="name" type="text" />
    <div>
      @if ((name?.dirty || name?.touched) && name?.errors?.["required"]) {
        <mat-error>Name is required.</mat-error>
      }
      @if ((name?.dirty || name?.touched) && name?.errors?.["minlength"]) {
        <mat-error
          >Minimum number of characters is
          {{ name?.errors?.["minlength"]?.["requiredLength"] }}.</mat-error
        >
      }
      @if ((name?.dirty || name?.touched) && name?.errors?.["maxlength"]) {
        <mat-error
          >Maximum number of characters is
          {{ name?.errors?.["maxlength"]?.["requiredLength"] }}.</mat-error
        >
      }
    </div>
  </mat-form-field>
  <mat-form-field class="event-form__input" appearance="fill">
    <mat-label for="clientName">Gym Name</mat-label>
    <input matInput formControlName="clientName" type="text" />
    <div>
      @if (
        (clientName?.dirty || clientName?.touched) &&
        clientName?.errors?.["required"]
      ) {
        <mat-error>Client Name is required.</mat-error>
      }
      @if (
        (clientName?.dirty || clientName?.touched) &&
        clientName?.errors?.["minlength"]
      ) {
        <mat-error
          >Minimum number of characters is
          {{
            clientName?.errors?.["minlength"]?.["requiredLength"]
          }}.</mat-error
        >
      }
      @if (
        (clientName?.dirty || clientName?.touched) &&
        clientName?.errors?.["maxlength"]
      ) {
        <mat-error
          >Maximum number of characters is
          {{
            clientName?.errors?.["maxlength"]?.["requiredLength"]
          }}.</mat-error
        >
      }
    </div>
  </mat-form-field>
  <mat-form-field class="event-form__input" appearance="fill">
    <mat-label>Dates</mat-label>
    <mat-date-range-input [rangePicker]="datePicker">
      <input
        matStartDate
        formControlName="startTime"
        placeholder="Start date"
      />
      <input matEndDate formControlName="endTime" placeholder="End date" />
    </mat-date-range-input>
    <mat-datepicker-toggle
      matIconSuffix
      [for]="datePicker"
    ></mat-datepicker-toggle>
    <mat-date-range-picker #datePicker></mat-date-range-picker>
    @if (startTime?.hasError("matStartDateInvalid")) {
      <mat-error>Invalid start date</mat-error>
    }
    @if (endTime?.hasError("matEndDateInvalid")) {
      <mat-error>Invalid end date</mat-error>
    }
    @if (isStartDateInPast()) {
      <mat-hint class="event-form__warning">
        <mat-icon>warning</mat-icon>
        Warning: Setting a start date in the past will lock the event
        immediately. Locked events cannot be edited.
      </mat-hint>
    }
  </mat-form-field>
  <mat-form-field class="event-form__input" appearance="fill">
    <mat-label for="streetAddress">Street Address</mat-label>
    <input matInput formControlName="streetAddress" type="text" />
    <div>
      @if (
        (streetAddress?.dirty || streetAddress?.touched) &&
        streetAddress?.errors?.["required"]
      ) {
        <mat-error>Street Address is required.</mat-error>
      }
      @if (
        (streetAddress?.dirty || streetAddress?.touched) &&
        streetAddress?.errors?.["minlength"]
      ) {
        <mat-error
          >Minimum number of characters is
          {{
            streetAddress?.errors?.["minlength"]?.["requiredLength"]
          }}.</mat-error
        >
      }
      @if (
        (streetAddress?.dirty || streetAddress?.touched) &&
        streetAddress?.errors?.["maxlength"]
      ) {
        <mat-error
          >Maximum number of characters is
          {{
            streetAddress?.errors?.["maxlength"]?.["requiredLength"]
          }}.</mat-error
        >
      }
    </div>
  </mat-form-field>
  <mat-form-field class="event-form__input" appearance="fill">
    <mat-label for="city">City</mat-label>
    <input matInput formControlName="city" type="text" />
    <div>
      @if ((city?.dirty || city?.touched) && city?.errors?.["required"]) {
        <mat-error>City is required.</mat-error>
      }
      @if ((city?.dirty || city?.touched) && city?.errors?.["minlength"]) {
        <mat-error
          >Minimum number of characters is
          {{ city?.errors?.["minlength"]?.["requiredLength"] }}.</mat-error
        >
      }
      @if ((city?.dirty || city?.touched) && city?.errors?.["maxlength"]) {
        <mat-error
          >Maximum number of characters is
          {{ city?.errors?.["maxlength"]?.["requiredLength"] }}.</mat-error
        >
      }
    </div>
  </mat-form-field>
  <mat-form-field class="event-form__input" appearance="fill">
    <mat-label for="state">State</mat-label>
    <input matInput formControlName="state" type="text" />
    <div>
      @if ((state?.dirty || state?.touched) && state?.errors?.["required"]) {
        <mat-error>State is required.</mat-error>
      }
      @if ((state?.dirty || state?.touched) && state?.errors?.["minlength"]) {
        <mat-error
          >Minimum number of characters is
          {{ state?.errors?.["minlength"]?.["requiredLength"] }}.</mat-error
        >
      }
      @if ((state?.dirty || state?.touched) && state?.errors?.["maxlength"]) {
        <mat-error
          >Maximum number of characters is
          {{ state?.errors?.["maxlength"]?.["requiredLength"] }}.</mat-error
        >
      }
    </div>
  </mat-form-field>
</form>
